import React from 'react';
import styles from './styles.module.scss';
import cn from 'classnames';

const H3 = ({ fontSize, marginBottom, ...props }) => (
  <h3 className={cn(styles.h3, props.styles)} style={{ fontSize, marginBottom, ...props.style }}>
    {props.children}
  </h3>
);

export default H3;
